import {Component} from 'solid-js'

export const DetailsField: Component<{ class?: string, key: string, value: string }> = (props) => <div class={props.class}>{props.key}: {props.value}</div>
